import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { Button, Container, Table } from 'react-bootstrap';
import { Title } from '../../components/Title/Title';
import { fetchAndSave } from '../../utils/utils';
import { useTranslation } from 'react-i18next';

const CompanyComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title>{t('legalese.labels.informazioniSocietarie')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>{t('legalese.labels.informazioniSocietarie')}</div>
        </div>
        <div className='mt-5'>
          <strong>EXAFLIX SRL</strong> <br />
          Rovigo (RO) <br />
          Via Alessandro Casalini 9 - CAP 45100 <br />
          Codice fiscale e Partita Iva n. 01671630299 <br />
          Registro delle Imprese di VENEZIA ROVIGO <br />
          Data iscrizione: 21/02/2025 <br />
          Numero REA RO - 462642 <br />
          Capitale sociale 10.000,00 (interamente versato)
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default CompanyComponent;
